
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/try/now",
      function () {
        return require("private-next-pages/try/now.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/try/now"])
      });
    }
  